// extracted by mini-css-extract-plugin
module.exports = {"root":"TableActions_root__i6Lr2","action":"TableActions_action__1MemO","linkAction":"TableActions_linkAction__3Hs-G"};